import styled from '@emotion/styled';
import H3 from '@base/H3/H3';
import { Spacings, breakpoints } from '@styles/index';
import P1 from '@base/P1/P1';
import { getImage } from '@utils/imageHelper';

const EnvelopeImg = styled.img`
  margin: ${Spacings.SPACING_13B} auto ${Spacings.SPACING_8B};
  @media only screen and (max-width: ${breakpoints.mobile}) {
    margin: ${Spacings.SPACING_8B} auto ${Spacings.SPACING_8B};
  }
`;

const StyH3 = styled(H3)`
  margin: 0 auto ${Spacings.SPACING_2B};
  text-align: center;
`;

const StyP1 = styled(P1)`
  text-align: center;
`;

const AlreadyFilled = () => {
  return (
    <>
      <EnvelopeImg
        src={getImage('physical-notes/envelope.svg')}
        width={Spacings.SPACING_32B}
        alt="filled"
      />
      <StyH3>We’ve already recorded your details</StyH3>
      <StyP1>Incase of any changes, please contact learner support team.</StyP1>
    </>
  );
};

export default AlreadyFilled;
